module.exports = __webpack_public_path__ + "static/media/ic_setting_gray.bc8a6f1f.svg";